/**
 * "Handed in" is the student's own act, and only a non-DRAFT submission records
 * it. A teacher opening "Upload responses" for a student creates a DRAFT shell
 * before any work exists, so status alone — not the mere existence of a row —
 * says whether that student still owes a response.
 */
export const isHandedIn = (submission) =>
  String(submission?.status || '').toUpperCase() !== 'DRAFT';

/**
 * Context-aware visibility for student roster.
 *
 * During active feedback run (bulk upload in progress), show ALL submissions
 * including DRAFT status so teachers can see all uploaded students immediately.
 * Otherwise, only show handed-in submissions.
 */
export const isVisibleInRoster = (submission, { isRunActive = false } = {}) => {
  if (isRunActive) {
    return true;
  }
  return isHandedIn(submission);
};

export default isHandedIn;
